<template>
	<div class="page__content">
		<div class="page__content__tools">
			<slot name="tools" />
		</div>
		<div class="page__content__content">
			<slot />
		</div>
	</div>
</template>

<script>
	export default {
		//props: ['title']
	}
</script>

<style lang="scss">
	.page {
		&__content {
			position: absolute;
			left: 0;
			top: 81px;
			bottom: 0;
			width: 100%;
			overflow: visible;

			&__content {
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				width: 100%;
				overflow: auto;
				-webkit-overflow-scrolling: touch;
			}

			&__tools {
				position: absolute;
				top: -80px;
				right: 0;
				height: 80px;
				padding: 20px 20px 20px;

				& > * {
					margin-left: 10px;
					float: left;
				}
			}
		}
	}

	@media only screen and (max-width: 600px) {
		.page__content {
			top: 41px;
		}
	}

	@media only screen and (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) { 
		.page__content {
			top: 81px;
		}
	}
</style>